import { useOrganizationFromRouterQuery } from "@dewo/app/containers/organization/hooks";
import { RoleDetailsPage as RolePage } from "@dewo/app/containers/organization/roles/RolePage";
import { useOrganizationRoleDetails } from "@dewo/app/containers/rbac/hooks";
import { OrganizationSeo } from "@dewo/app/containers/seo/OrganizationSeo";
import { useRouter } from "next/router";
import React, { FC, useMemo } from "react";

const Page: FC<{}> = () => {
  const router = useRouter();
  const roleId = router.query.roleId as string;
  const organization = useOrganizationFromRouterQuery();

  const { roles } = useOrganizationRoleDetails(organization?.id);
  const role = useMemo(
    () => roles?.find((r) => r.id === roleId && r.featured),
    [roles, roleId]
  );

  return (
    <>
      <RolePage role={role} organizationId={organization?.id} />
      <OrganizationSeo />
    </>
  );
};

export default Page;
